import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';

import ExportIcon from '~/shared/assets/icons/export.svg';
import Typography from '~/shared/components/Typography';
import FilterButton from '~/shared/components/filters/FilterButton';
import Button from '~/shared/components/ButtonsV2';
import { SelectOption } from '~/shared/utils/types';
import { useExportState } from '~/shared/context/ExportStateContext';

import FleetManagerFiltersSidePanel from '../AllVolumesFiltersSidePanel/AllVolumesFiltersSidePanel';
import VolumesExportModal from './VolumesExportModal';

interface AllVolumesTableHeaderProps {
  dataCount: number | undefined;
  activeFilterCount: number;
  sidePanelOpen: boolean;
  onTogglePanel: () => void;
  onSetPanelOpen?: (open: boolean) => void;
  onResetFilters: () => void;
  appliedClusterNameFilters: SelectOption[];
  appliedInstanceFilters: SelectOption[];
  appliedVolumeIdFilters: SelectOption[];
  appliedVolumeTagFilters: SelectOption[];
  appliedAutoscaleState: string[];
  activeFilters: SelectOption[];
  sortField: { field: string; dir: 'desc' | 'asc' };
}

export function AllVolumesTableHeader({
  dataCount,
  activeFilterCount,
  sidePanelOpen,
  onTogglePanel,
  onSetPanelOpen,
  onResetFilters,
  appliedClusterNameFilters,
  appliedInstanceFilters,
  appliedVolumeIdFilters,
  appliedVolumeTagFilters,
  appliedAutoscaleState,
  activeFilters,
  sortField,
}: AllVolumesTableHeaderProps) {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const { isExporting } = useExportState();
  const volumesExporting = isExporting('volumes');

  return (
    <div className="flex justify-between pt-3 2xl:pt-[18px]  bgred/5">
      <div className="flex items-center gap-7 ">
        {dataCount !== undefined ? (
          <Typography variant="p1" fontWeight={500} className="text-primary-900 font-family-inter">
            {dataCount} Detected Volumes
          </Typography>
        ) : (
          <Skeleton
            containerClassName="block leading-[unset!important]"
            className="h-[20px] leading-[unset!important] rounded-[8px] "
            baseColor="var(--color-gray-200)"
            highlightColor="#FFF"
            width={200}
          />
        )}
      </div>
      <div className="flex gap-2 items-center justify-end w-full max-w-[713px]">
        <Button
          variant={'third'}
          onClick={() => { if (!volumesExporting) setIsExportModalOpen(true); }}
          className="w-10"
          size="md-responsive"
          loading={volumesExporting}
          disabled={volumesExporting}
          icon={<ExportIcon className="size-5" />}
        />
        {/* <Button className="w-10" variant="text" icon={<EditIcon />} onClick={onEdit} /> */}
        <FilterButton
          activeFilterCount={activeFilterCount}
          onOpen={onTogglePanel}
          onClearAll={onResetFilters}
          size="md-responsive"
          variant="third"
        />
      </div>

      <VolumesExportModal
        isOpen={isExportModalOpen}
        onClose={() => setIsExportModalOpen(false)}
        activeFilters={activeFilters}
        sortField={sortField}
        totalCount={dataCount}
      />
      <FleetManagerFiltersSidePanel
        open={sidePanelOpen}
        onOpenChange={(open: boolean) => {
          if (onSetPanelOpen) {
            onSetPanelOpen(open);
          } else {
            // Fallback: toggle only when change differs to avoid accidental close/open loops
            if (open !== sidePanelOpen) {
              onTogglePanel();
            }
          }
        }}
        onResetFilters={onResetFilters}
        appliedClusterNameFilters={appliedClusterNameFilters}
        appliedInstanceFilters={appliedInstanceFilters}
        appliedVolumeIdFilters={appliedVolumeIdFilters}
        appliedVolumeTagFilters={appliedVolumeTagFilters}
        appliedAutoscaleState={appliedAutoscaleState}
      />
    </div>
  );
}
